import React, { useEffect, useState } from "react";


const AccessControl = (props) => {
    
    const {children, userPermissions=[], allowedPermissions = [], renderNoAccess} = props;

    const [loading, setLoading] = useState(true);
    const [permitted, setPermitted] = useState(false);
    
    useEffect(()=> {
        if(allowedPermissions.length == 0){
            setPermitted(true);
        } else {
            let found = false;
            for(let i in allowedPermissions){
                if(userPermissions?.find(item => item == allowedPermissions[i])){
                    found = true;
                    break;
                }
            }
            setPermitted(found);
        }
        setLoading(false);
    }, [userPermissions, allowedPermissions]);

    if(loading){
        return (
            <div>
                loading...
            </div>
        );
    }

    if(!permitted){
        return renderNoAccess();
    }

    return (
        <>
            {children}
        </>
    );
}

export default AccessControl;
